// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_pAl","field":"styles_field__3yt6A","fieldCol":"styles_fieldCol__-UHoD","diffCol":"styles_diffCol__3WfA9","diff":"styles_diff__3GS1T"};